import React from 'react';

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Accessible name, used when the toggle has no visible <label>. */
  ariaLabel?: string;
  className?: string;
}

/**
 * Small pill switch: primary fill when on, white knob with a matching inner
 * dot. Measures 28x16 to match the Dash form designs.
 */
export const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  disabled = false,
  ariaLabel,
  className = '',
}) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex w-7 h-4 shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 ${
        checked ? 'bg-primary' : 'bg-gray-300'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className}`.trim()}
    >
      <span
        className={`inline-flex items-center justify-center w-3 h-3 rounded-full bg-white transition-transform ${
          checked ? 'translate-x-[14px]' : 'translate-x-[2px]'
        }`}
      >
        <span
          className={`w-1 h-1 rounded-full ${
            checked ? 'bg-primary' : 'bg-gray-300'
          }`}
        />
      </span>
    </button>
  );
};

export default Toggle;
